<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="takeout_dining"
            name="name"
            v-model="form.name"
            :label="$t('delivery.product.labels.name')"
            :placeholder="$t('delivery.product.labels.name')"
            :error="hasInputErrors('name')"
            :error-messages="getInputErrors('name')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="short_text"
            name="name"
            v-model="form.shortName"
            :label="$t('delivery.product.labels.shortName')"
            :placeholder="$t('delivery.product.labels.shortName')"
            :error="hasInputErrors('shortName')"
            :error-messages="getInputErrors('shortName')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="description"
            name="description"
            v-model="form.description"
            :label="$t('delivery.product.labels.description')"
            :placeholder="$t('delivery.product.labels.description')"
            :error="hasInputErrors('description')"
            :error-messages="getInputErrors('description')"
            color="secondary"

        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <media-field
            icon="photo_camera"
            fieldName="image"
            :label="$t('delivery.product.labels.image')"
            :placeholder="$t('delivery.product.labels.image')"
            v-model="form.image">

        </media-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="price_change"
            name="price"
            v-model.number="form.price"
            type="number"
            :label="$t('delivery.product.labels.price')"
            :placeholder="$t('delivery.product.labels.price')"
            :error="hasInputErrors('price')"
            :error-messages="getInputErrors('price')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <ingredient-combobox v-model="form.ingredients" :input-errors="inputErrors"/>
      </v-col>


      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="toggle_on"
            name="active"
            v-model="form.active"
            :label="$t('delivery.product.labels.active')"
            :error="hasInputErrors('active')"
            :error-messages="getInputErrors('active')"
            color="secondary"

        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="star"
            name="featured"
            v-model="form.featured"
            :label="$t('delivery.product.labels.featured')"
            :error="hasInputErrors('featured')"
            :error-messages="getInputErrors('featured')"
            color="secondary"

        ></v-checkbox>
      </v-col>


      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="home"
            name="homeGallery"
            v-model="form.homeGallery"
            :label="$t('delivery.product.labels.homeGallery')"
            :error="hasInputErrors('homeGallery')"
            :error-messages="getInputErrors('homeGallery')"
            color="secondary"

        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <product-category-combobox
            v-model="form.categories"
            :input-errors="inputErrors"
            @input="updateImageCategory"
        />
      </v-col>

      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            Imagenes por categoría
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-for="(item,index) in form.imageCategory" :key="item.category">
                <media-field
                    icon="photo_camera"
                    fieldName="image"
                    :label="getCategoryName(item.category)"
                    :placeholder="getCategoryName(item.category)"
                    v-model="form.imageCategory[index].image">
                </media-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import {MediaField} from '@dracul/media-frontend'

import IngredientCombobox from "./IngredientCombobox";
import ProductCategoryCombobox from "./ProductCategoryCombobox";


export default {
  name: "ProductForm",
  mixins: [InputErrorsByProps, RequiredRule],
  components: {
    IngredientCombobox,
    ProductCategoryCombobox,
    MediaField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    imageCategoryExist() {
      return category => {
        return this.form.imageCategory.some(i => i.category === category)
      }
    },
    categoryExist() {
      return category => {
        return this.form.categories.some(i => i.category === category)
      }
    },
    getCategoryName() {
      return categoryId => {
        return this.$store.getters.getCategoryNameById(categoryId)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    updateImageCategory() {


      this.form.imageCategory = this.form.imageCategory.filter(i => this.categoryExist(i.category))

      for (let category of this.form.categories) {
        if (!this.imageCategoryExist(category)) {
          this.form.imageCategory.push({
            category: category,
            image: ''
          })
        }
      }

    },
    validate() {
      return this.$refs.form.validate()
    }
  },
  created() {
    this.$store.dispatch('fetchCategories')

  },
  mounted() {
    if( this.form.imageCategory.length === 0){
      this.updateImageCategory()
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

